module.exports = __webpack_public_path__ + "front/img/p16.0ea98e51.png";